<template>
	<div>
		<div v-if="contest">
			<div>
				<h1>{{ contest.title }} Voting Totals Page</h1>
			</div>
			<div v-for="(categoryEntries, categoryTitle) in categories">
				<div
					v-if="categoryEntries.length"
				>
					<h3>{{ categoryTitle }}</h3>
					<table>
						<thead style="font-size: 12px;">
						<th style="padding-right: 8px;">Image</th>
						<th style="padding-right: 8px;">Total</th>
						</thead>
						<tr v-for="entry in categoryEntries">

							<td
								style="width: 200px; font-size: 12px; line-height: 14px; padding: 4px 0px;"
								class="hover-show-image"
							>
								<a
									:href="entry.main_image ? entry.main_image.full : ''"
									target="_blank"
								>
									{{ entry.item_name }}
								</a>
								<img
									style="display: none; position: absolute; max-width: 200px;"
									:src="entry.main_image ? entry.main_image.large : ''" />
							</td>
							<td>
								{{
									entry.judgeVotes
								}}
							</td>
						</tr>
					</table>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import axios from "axios";
export default {
	name: 'judging-form',
	data() {
		return {
			refreshKey: 0,
			isAnotherValue: '',
			categories: {},
			categoriesJSON: '',
			judge: {
				name: null,
				email: null,
			},
			contest: null,
			totalEntries: 0,
			displayThanks: false,
		}
	},
	mounted() {
		const laravelAuthToken = localStorage.getItem('laravelAuthToken');
		let authHeaders = {
			headers: {"Authorization" : `Bearer ${laravelAuthToken}`}
		};
		axios.get(`/api/contests/${this.$route.params.contest}/judging-form-totals`, authHeaders).then((res) => {
			const data = res.data.serverData;
			this.categories = data.categories;
			this.categoriesJSON = JSON.stringify(data.categories);
			this.contest = data.contest;
			this.totalEntries = data.totalEntries;
		})
	},
}
</script>
<style>
.hover-show-image:hover > div > img {
	display: block !important;
}
.hover-show-image:hover > img {
	display: block !important;
}
</style>